
  import { defineComponent, PropType } from 'vue';

  import IndicatorCard from '@/common/components/redesigned/IndicatorCard.vue';
  import { TReadableStorePaths } from '@/common/types/storePaths';

  import { TDashboardMainFilter, TMainFilterPayload, TTopPartnerRating } from '../../types/dashboards';
  import TopStatisticChart from '../common/TopStatisticChart.vue';

  export default defineComponent({
    name: 'DashboardsChartCard',
    components: {
      TopStatisticChart,
      IndicatorCard,
    },
    emits: ['barClick'],
    props: {
      filter: {
        type: Object as PropType<TDashboardMainFilter & Record<string, string | number>>,
        required: true,
      },
      title: {
        type: String,
      },
      storePaths: {
        type: Object as PropType<TReadableStorePaths>,
        required: true,
      },
      isBarClickable: {
        type: Boolean,
        default: false,
      },
      hideWhenEmpty: {
        type: Boolean,
        default: false,
      },
    },
    data: (): { topCountryPartnersAbortController: AbortController; isLoading: boolean } => {
      return {
        topCountryPartnersAbortController: new AbortController(),
        isLoading: false,
      };
    },
    methods: {
      searchData(params: TMainFilterPayload) {
        return this.$store.dispatch(this.storePaths.action, params);
      },
    },
    computed: {
      items(): Array<TTopPartnerRating> {
        return this.$store.getters[this.storePaths.getter] ?? [];
      },
    },
    watch: {
      filter: {
        async handler() {
          this.topCountryPartnersAbortController.abort();
          this.topCountryPartnersAbortController = new AbortController();

          const payload: TMainFilterPayload = {
            params: this.filter,
            abortController: this.topCountryPartnersAbortController,
          };

          try {
            this.isLoading = true;
            this.items = await this.searchData(payload);
          } finally {
            this.isLoading = false;
          }
        },
        immediate: true,
        deep: true,
      },
    },
  });
